module.exports = __webpack_public_path__ + "img/browser_vatu.0dd490fe.svg";